module.exports = __webpack_public_path__ + "img/RedteaSIM_EN04.bbd826f7.png";